import { useEffect, useRef, useState } from "react";

function Timer({ initialMinutes, initialSeconds=0, onThreeMinuteWarning, onTimeUp }) {
  const [timeLeft, setTimeLeft] = useState({
    minutes: initialMinutes,
    seconds: initialSeconds
  });

  const warningShownRef = useRef(false);
  const intervalRef = useRef(null);
  const timeUpCalledRef = useRef(false);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setTimeLeft(prevTime => {
        const { minutes, seconds } = prevTime;

        if (minutes === 5 && seconds === 0 && !warningShownRef.current) {
          onThreeMinuteWarning();
          warningShownRef.current = true;
        }

        if (minutes === 0 && seconds === 0) {
          if (!timeUpCalledRef.current) {
            timeUpCalledRef.current = true;
            onTimeUp();
          }
          clearInterval(intervalRef.current);
          return { minutes: 0, seconds: 0 };
        }

        if (seconds === 0) {
          return { minutes: minutes - 1, seconds: 59 };
        }

        return { ...prevTime, seconds: seconds - 1 };
      });
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [onThreeMinuteWarning, onTimeUp]);

  return (
    <span>
      {String(timeLeft.minutes).padStart(2, '0')}:{String(timeLeft.seconds).padStart(2, '0')}
    </span>
  );
}

export default Timer;
